import { AxiosInstance, AxiosResponse } from 'axios'
import { call, getContext, select, take } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'

import { ConfigActions, getUmbracoConfigLoadStatus } from '../redux/config'
import { ConfigLoadingState } from '../redux/config/types'

import { apiCall } from './api'
import { downloadFile } from './download'

export function* waitForConfigLoad() {
  const configLoaded: ConfigLoadingState = yield select(getUmbracoConfigLoadStatus)
  if (configLoaded !== ConfigLoadingState.Loaded) {
    let action: ReturnType<typeof ConfigActions.setConfigLoadingState>
    do {
      action = yield take(getType(ConfigActions.setConfigLoadingState))
    } while (action.payload.state !== ConfigLoadingState.Loaded)
  }
}

export function* downloadExportViaToken(exportId: string, context?: string) {
  const axios: AxiosInstance = yield getContext('axios')

  const basePath = context ? `/api/${context}/export` : '/api/export'

  const {
    data
  }: AxiosResponse<{
    token: string
  }> = yield call(apiCall, {
    url: `${basePath}/token`,
    method: 'get',
    params: {
      id: exportId
    }
  })

  yield call(
    downloadFile,
    `${axios.defaults.baseURL || ''}${basePath}?id=${exportId}&token=${data.token}`,
    document.body
  )
}
